import { Domain } from "../../apis/mgmt/api";
import { DataFormWithButtonsLayout } from "../common/DataFormWithButtonsLayout";
import { EditableProps } from "../common/Editable";
import { DomainForm } from "./DomainForm";


export const DomainEditable = function (
    props: EditableProps<Domain>
) {

    return (
        <DataFormWithButtonsLayout editableProps={props} saveAndStay={true}>
            <DomainForm {...props} />
        </DataFormWithButtonsLayout>
    );

};
